var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeviasCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4624_34671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 4.6875C0.25 3.09597 1.51982 1.8125 3.07882 1.8125H18.4729C20.0296 1.8125 21.3017 3.0961 21.3017 4.6875V20.3125C21.3017 21.9016 20.0295 23.1875 18.4729 23.1875H3.07882C1.51995 23.1875 0.25 21.9017 0.25 20.3125V4.6875ZM2.05911 4.6875V20.3125C2.05911 20.8763 2.51159 21.3438 3.07882 21.3438H18.4729C19.0378 21.3438 19.4926 20.8767 19.4926 20.3125V4.6875C19.4926 4.1209 19.0374 3.65625 18.4729 3.65625H3.07882C2.51199 3.65625 2.05911 4.12131 2.05911 4.6875Z",
    fill: "#231F20",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4624_34671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.5517,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeviasCheckbox);
export default __webpack_public_path__ + "static/media/levias-checkbox.2dadc5632b5bc6fec1240c8071869d5b.svg";
export { ForwardRef as ReactComponent };